const routes = [
  {
    path: 'alerts',
    component: () => import('@/views/home/AlertWrapper.vue'),
    children: [
      {
        path: '/',
        name: 'alertDetails',
        component: () => import('@/views/home/AlertDetails.vue'),
      },
    ],
  },
];

export default routes;
